import React, { useEffect, useState } from "react";
import { isMobile } from 'react-device-detect';
import { useSearchParams } from 'react-router-dom';
import { InputPhoneNumber, phoneNumberIsMatch, routes } from "../components";
import { auth } from '../components/api';
import { successValidationStatus, errorValidationStatus } from '../components/antd';
import { Space, Form, Button, Input, Typography, ConfigProvider, Flex } from 'antd';
import { LockOutlined } from "@ant-design/icons";
import logo from '../assets/authorizationLogo.svg';
import { getCompanyNameTheme, getProductNameTheme, getPageTheme } from '../styles/pages/authorization';
import {_colors} from '../styles/themes';
import "../styles/authorization.scss";
import "../styles/authorization-mobile.scss";

export const Authorization = React.forwardRef((props, ref) => {
    const [form] = Form.useForm();

    const [searchParams] = useSearchParams();
    const returnUrl = searchParams.get('returnUrl');

    const phoneNumberErrorText = 'Номер телефона должен содержать 10 цифр';
    const [phoneNumberValidationStatus, setPhoneNumberValidationStatus] = useState(successValidationStatus);
    const [phoneNumberHelpText, setPhoneNumberHelpText] = useState(null);

    const passwordErrorText = 'Неправильный пароль. Повторите попытку или нажмите на “Забыли пароль?”';
    const [passwordValidationStatus, setPasswordValidationStatus] = useState(successValidationStatus);
    const [passwordHelpText, setPassordHelpText] = useState(null);
    const [hasFeedbackPasswordFiels, setHasFeedbackPasswordFiels] = useState(false);

    const { Text } = Typography;

    useEffect(() => {
        if (phoneNumberValidationStatus === errorValidationStatus)
            setPhoneNumberHelpText(phoneNumberErrorText);
        else
            setPhoneNumberHelpText(null);

        if (passwordValidationStatus === errorValidationStatus) {
            setPassordHelpText(passwordErrorText);
            setHasFeedbackPasswordFiels(true);
        } else {
            setPassordHelpText(null);
            setHasFeedbackPasswordFiels(false);
        }
    }, [phoneNumberValidationStatus, passwordValidationStatus]);

    const handleFormFinish = (fieldsValue) => {
        let hasError = false;

        if (fieldsValue.phoneNumber && phoneNumberIsMatch(fieldsValue.phoneNumber)) {
            setPhoneNumberValidationStatus(successValidationStatus);
        }
        else {
            setPhoneNumberValidationStatus(errorValidationStatus);
            hasError = true;
        }

        if (fieldsValue.password) {
            setPasswordValidationStatus(successValidationStatus);
        }
        else {
            setPasswordValidationStatus(errorValidationStatus);
            hasError = true;
        }

        if (hasError)
            return;

        const formatedPhone = '7' + fieldsValue.phoneNumber?.replace(/\D/g, '');

        auth(formatedPhone, fieldsValue.password).then(
            () => {
                window.location.href = returnUrl ?? "/";

                setPhoneNumberValidationStatus(successValidationStatus);
                setPasswordValidationStatus(successValidationStatus);
            },
            (error) => {
                setPhoneNumberValidationStatus(errorValidationStatus);
                setPasswordValidationStatus(errorValidationStatus);

                form.resetFields(['password']);
            },
        );
    };

    //*** Внутренние элементы управления ***//

    const CompanyLogo = () => (
        <img src={logo} preview={{ open: false }} />
    );

    const CompanyName = () => (
        <ConfigProvider theme={getCompanyNameTheme()}>
            <Text strong className={isMobile ? 'authorization-mobile__company-name' : 'authorization__company-name'}>боравто</Text>
        </ConfigProvider>
    );

    const ProductName = () => (
        <ConfigProvider theme={getProductNameTheme()}>
            <Text strong className={isMobile ? 'authorization-mobile__project-name' : 'authorization__project-name'}>аукцион</Text>
        </ConfigProvider>
    );

    const LoginForm = () => {
        const formElementClassName = 'authorization__interaction-window__form__element';

        const getFormElementClassName = () => isMobile ? '' : formElementClassName;

        const PhoneNumber = () => (
            <Form.Item
                name="phoneNumber"
                className={getFormElementClassName()}
                validateStatus={phoneNumberValidationStatus}
                help={phoneNumberHelpText}
            >
                <InputPhoneNumber size='large' />
            </Form.Item>
        );

        const Password = () => (
            <Form.Item
                name="password"
                className={getFormElementClassName()}
                hasFeedback={hasFeedbackPasswordFiels}
                validateStatus={passwordValidationStatus}
                help={passwordHelpText}
            >
                <Input.Password
                    size="large"
                    placeholder="Пароль"
                    prefix={<LockOutlined style={{ color: _colors.grey2 }}/>}
                />
            </Form.Item>
        );

        const LoginButton = () => (
            <Form.Item>
                <Flex vertical align="stretch">
                    <Button size="large" type="primary" htmlType="submit" className={getFormElementClassName()}>Войти</Button>
                </Flex>
            </Form.Item>
        );

        const RegistrationButton = () => (
            <Flex vertical align="stretch">
                <Button size="large" href={routes.registration} className={getFormElementClassName()}>Зарегистрироваться</Button>
            </Flex>
        );

        const PasswordRecoveryButton = () => (
            <Flex vertical align="stretch">
                <Button size="large" type="link" href={routes.passwordRecovery} className={getFormElementClassName()}>Забыли пароль?</Button>
            </Flex>
        );

        return (
            <Form
                form={form}
                onFinish={handleFormFinish}
            >
                <Flex vertical gap="large" justify="center" align="stretch">
                    <Space vertical size="small">
                        <PhoneNumber />
                        <Password />
                    </Space>
                    <Space vertical size="small">
                        <LoginButton />

                        <RegistrationButton />
                        <PasswordRecoveryButton />
                    </Space>
                </Flex>
            </Form>
        );
    };

    const Container = ({ children }) => (
        <ConfigProvider theme={getPageTheme()}>
            {
                isMobile
                    ?
                    (
                        <Flex vertical gap="large" align="stretch" justify="center" className="authorization-mobile__main">
                            <Space vertical size="large">
                                {children}
                            </Space>
                        </Flex>
                    )
                    :
                    <Flex vertical align="center" justify="center" className="authorization__main">
                        <Flex vertical gap="large" align="center" justify="center" className="authorization__interaction-window">
                            {children}
                        </Flex>
                    </Flex>
            }
        </ConfigProvider>
    );

    return (
        <Container>
            <Space.Compact vertical>
                <CompanyLogo />
                <CompanyName />
                <ProductName />
            </Space.Compact>

            <LoginForm />
        </Container>
    )
})